import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { DMTokenErrorType } from '#src/types/DmTokenTypes'

export default class DMTokenError extends BaseError<DMTokenErrorType> {
  constructor(
    public message: string,
    public code: DMTokenErrorType,
    public options?: {
      cause: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, DMTokenError.prototype)
    this.name = this.constructor.name
  }
}
